// test2157
(2157 && 0);
